<script setup>
import {onMounted, ref, reactive} from "vue";
import router from "@/router/index.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {listLesson} from "@/api/lesson/lesson.js";
import YTLessonState from "@/components/YTLessonState/index.vue"

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*权限相关*/

/*搜索功能*/
// 表单数据
const formData = reactive({
  keyword: null,
  lessonStartTime: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    console.log("formData", formData.lessonStartTime)
    const res = await listLesson(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.lessonStartTime = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '课程名称', key: 'courseName', minWidth: "120px", nowrap: true },
  { title: '时间', key: 'lessonStartTime', minWidth: "150px", nowrap: true },
  { title: '教练', key: 'coachName', minWidth: "120px", nowrap: true },
  { title: '学员人数', key: 'studentCount', minWidth: "120px", nowrap: true },
  { title: '状态', key: 'lessonState', minWidth: "120px", nowrap: true },
  { title: '操作', key: 'controls', minWidth: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 展示的详情信息
const detailInfo = ref()
// 获取详情信息
const getDetail = (info) => {
  detailInfo.value = info
  router.push({path: "/addClubCourseRecord", query: {lessonId: detailInfo.value.lessonId}})
}

/*跳转新建*/
const handleAdd = () => {
  router.push("/addClubCourseRecord")
}
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd" :disabled="!$handleHasBtnPermission('any', 'lesson:add')">新建课程记录</v-btn>
    </div>
  </div>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="max-width: 220px;text-align: left"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <el-form-item label="课程名称：" prop="keyword">
        <el-input v-model="formData.keyword" placeholder="请输入课程名称"></el-input>
      </el-form-item>
      <el-form-item label="课程时间：" prop="lessonStartTime">
        <el-date-picker
            v-model="formData.lessonStartTime"
            type="date"
            placeholder="请选择课程时间"
            value-format="YYYY-MM-DD"
        />
      </el-form-item>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'lesson:view')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'lesson:view')">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.lessonState="{ item }">
            <YTLessonState :state="item.lessonState"></YTLessonState>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="getDetail(item)" v-show="item.lessonState === 'PENDING' && $handleHasBtnPermission('all', 'lesson:edit')"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>